import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorsModule } from '../../util/colors/colors.module';
import { MaterialModule } from '../../util/material/material.module';
import { CustomColorComponent } from './custom-color.component';
import { ColorPickerCardModule } from '../../util/colors/color-picker-card/color-picker-card.module';
import { ColorViewModule } from '../../util/colors/color-view/color-view.module';



@NgModule({
  declarations: [CustomColorComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ColorsModule,
    ColorPickerCardModule,
    ColorViewModule
  ],
  exports: [CustomColorComponent]
})
export class CustomColorModule { }
